import { Editor } from "@tiptap/core";

export const applySelectionHighlight = (editor: Editor | null, from: number, to: number) => {
  if (!editor) return;
  editor.commands.command(({ tr, state, dispatch }) => {
    const markType = state.schema.marks.selectionHighlight;
    if (!markType || from === to) return false;
    tr.addMark(from, to, markType.create());
    tr.setMeta("addToHistory", false);
    if (dispatch) dispatch(tr);
    return true;
  });
};

export const clearSelectionHighlight = (editor: Editor | null) => {
  if (!editor) return;
  editor.commands.command(({ tr, state, dispatch }) => {
    const markType = state.schema.marks.selectionHighlight;
    if (!markType) return false;
    let hasChanges = false;
    state.doc.descendants((node, pos) => {
      if (!node.isText) return;
      if (markType.isInSet(node.marks)) {
        tr.removeMark(pos, pos + node.nodeSize, markType);
        hasChanges = true;
      }
    });
    if (hasChanges && dispatch) {
      tr.setMeta("addToHistory", false);
      dispatch(tr);
    }
    return hasChanges;
  });
};
